import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { ApolloLink } from '@apollo/client';
export var cloudflareAccessLink = /*#__PURE__*/new ApolloLink(function (operation, forward) {
  if (process.env.APP_ENV !== 'production' && process.env.CLOUDFLARE_ACCESS_CLIENT_ID && process.env.CLOUDFLARE_ACCESS_CLIENT_SECRET) {
    operation.setContext(function (_ref) {
      var _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers;
      return {
        headers: _objectSpread(_objectSpread({}, headers), {}, {
          'CF-Access-Client-Id': process.env.CLOUDFLARE_ACCESS_CLIENT_ID,
          'CF-Access-Client-Secret': process.env.CLOUDFLARE_ACCESS_CLIENT_SECRET
        })
      };
    });
  }
  return forward(operation);
});
export default cloudflareAccessLink;